import { Location } from '@angular/common';
import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { Router } from '@angular/router';
import { ToolService } from '@app/core/services/tool/tool.service';
import { NavController } from '@ionic/angular';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-details-not-found',
    templateUrl: './program-not-found.component.html',
    styleUrls: ['./program-not-found.component.css'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramNotFoundComponent implements OnInit {
    constructor(
        private navController: NavController,
        private location: Location,
        public toolService: ToolService,
        private router: Router,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager
    ) {}

    ngOnInit() {
        // // parse out the programId
        // const programId = this.location
        //     .path()
        //     .replace('/program/', '')
        //     .split('?')[0];
        // // GTM push custom dimensions to the dataLayer
        // this.angulartics2GoogleTagManager.pushLayer({ cdProgramId: programId });
        // // trigger Analytics event program not found
        // // do a "simple" valid number check
        // if (/^-?\d+$/.test(programId)) {
        //     this.angulartics2GoogleTagManager.eventTrack('Program Not Found', {
        //         category: 'Program',
        //     });
        // } else {
        //     this.angulartics2GoogleTagManager.eventTrack(
        //         'Program Not Found Invalid Format',
        //         { category: 'Program' }
        //     );
        // }
    }

    search = () => {
        const newUrl = '/search';
        const url = this.router.createUrlTree([`${newUrl}`]).toString();
        this.location.replaceState(url);
        this.navController.navigateRoot(['/search']);
    };
}
